<template>
  <div class="checkout-address-form">
    <div class="row">
      <div class="col-md-6 mb-3">
        <b-card class="my-2 px-0 h-100">
          <div>
            <label for="customer-dropdown"><h5>Shipping Notes</h5></label>
            <b-icon style="vertical-align: middle" id="shipping-notes-help" icon="question-circle-fill" variant="info" class="h5 ml-1" />
          </div>
          <template v-if="false">
            <label for="shipping-method-dropdown">Shipping Method:</label>
            <div class="form-group row">
              <div class="col-md-12">
                <select
                  id="shipping-method-dropdown"
                  class="form-control"
                  v-model="shippingMethod"
                >
                  <option
                    v-for="method in shippingMethods"
                    :key="method"
                    :value="method"
                  >
                    {{ method }}
                  </option>
                </select>
              </div>
            </div>
          </template>
          <label for="customer-dropdown">Shipping Instructions:</label>
          <div class="form-group row" v-if="shippingNotes.filter(c => c.trim() !== '').length > 0 || (orderItemNotes && orderItemNotes.length > 0)">
            <div class="col-md-12">
              <b-input-group size="sm">
                <b-form-textarea
                  rows="3"
                  max-rows="8"
                  readOnly="readOnly"
                  :id="'shipping-notes'"
                  v-model="shippingNotesText"
                >
                </b-form-textarea>
              </b-input-group>
            </div>
          </div>
          <div class="form-group row"
            v-for="comment in shippingInstructions"
            :key="comment.key">
            <div class="col-md-12">
              <b-input-group size="sm">
                <b-form-input
                  v-model="comment.value"
                  type="text"
                  :id="'shipping-instructions-' + comment.key"
                  @input="onShippingInstructionsChange(comment)"
                  maxlength="132"
                />
                <b-input-group-append>
                  <b-input-group-text @click="onShippingInstructionsDelete(comment)" style="cursor:pointer">
                    <b-icon-trash variant="danger" />
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>

          <label for="customer-dropdown">Special Instructions:</label>
          <div
            class="form-group row"
            v-for="(comment) in specialInstructions"
            :key="comment.key">
            <div class="col-md-12">
              <b-input-group size="sm">
                <b-form-input
                  v-model="comment.value"
                  type="text"
                  :id="'shipping-instructions-' + comment.key"
                  @input="onSpecialInstructionsChange(comment)"
                  maxlength="132"
                />
                <b-input-group-append>
                  <b-input-group-text @click="onSpecialInstructionsDelete(comment)" style="cursor:pointer">
                    <b-icon-trash variant="danger" />
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>

          <label for="customer-dropdown">Tagging Information:</label>
          <div
            class="form-group row"
            v-for="(comment) in taggingInformation"
            :key="comment.key">
            <div class="col-md-12">
              <b-input-group size="sm">
                <b-form-input
                  v-model="comment.value"
                  type="text"
                  :id="'tagging-information-' + comment.key"
                  @input="onTaggingfInformationChange(comment)"
                  maxlength="132"
                />
                <b-input-group-append>
                  <b-input-group-text @click="onTaggingfInformationDelete(comment)" style="cursor:pointer">
                    <b-icon-trash variant="danger" />
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>

          <label for="customer-dropdown">Additional Instructions:</label>
          <div
            class="form-group row"
            v-for="(comment) in additionalInstructionsFromInquiry"
            :key="comment.key">
            <div class="col-md-12">
              <b-input-group size="sm">
                <b-form-input
                  v-model="comment.value"
                  type="text"
                  :id="'additional-instructions-' + comment.key"
                  @input="onAdditionalInstructionsChange(comment)"
                  readonly="readonly"
                />
              </b-input-group>
            </div>
          </div>
          <div
            class="form-group row"
            v-for="(comment) in additionalInstructions"
            :key="comment.key">
            <div class="col-md-12">
              <b-input-group size="sm">
                <b-form-input
                  v-model="comment.value"
                  type="text"
                  :id="'additional-instructions-' + comment.key"
                  @input="onAdditionalInstructionsChange(comment)"
                  maxlength="132"
                />
                <b-input-group-append>
                  <b-input-group-text @click="onAdditionalInstructionsDelete(comment)" style="cursor:pointer">
                    <b-icon-trash variant="danger" />
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-6 mb-3">
        <b-card class="my-2 px-0 h-100">
          <!-- TODO: should be b-card-header -->
          <h5>Documents</h5>
          <b-card-body class="p-0">
            <div>
              <label for="customer-dropdown">Purchase Order Documentation is Required</label>
              <b-icon style="vertical-align: middle" id="purchase-order-documentation-help" icon="question-circle-fill" variant="info" class="h5 ml-1" />
            </div>
            <div>
              <file-upload
                v-model="files"></file-upload>
              <div v-if="poDocumentNotSelectedMessage.length > 0" class="text-danger">
                <small>{{ poDocumentNotSelectedMessage }}</small>
              </div>
            </div>
          </b-card-body>
          <template v-if="inquiryFiles && inquiryFiles.length">
            <b-card-body class="p-0">
              <!-- TODO: should be b-card-header -->
              <label for="customer-dropdown" class="mb-1 mt-2">Inquiry Files:</label>
              <b-form-radio-group @change="onInquiryFilesChange($event)" stacked v-model="selectedInquiryFile">
                <div @click="onInquiryFilesClick(fileItem)" v-for="(fileItem, index) in inquiryFiles" :key="fileItem.Id">
                  <b-form-radio :value="fileItem" style="display:grid" stacked>
                    <b-card no-body>
                      <b-card-header
                        :class="fileItem.Id == selectedInquiryFile?.Id ? 'background-color-primary': 'background-color-white'"
                        :header-text-variant="fileItem.Id == selectedInquiryFile?.Id ? 'white': 'dark'"
                      >
                        {{ fileItem.Name }}
                        <b-button-toolbar class="float-md-right">
                          <b-button-group size="sm">
                            <b-button clas="p-0" title="Remove File" variant="link"
                              @click.stop="removeFileAt(index)"
                            >
                            <b-icon-trash variant="danger" />
                            </b-button>
                          </b-button-group>
                        </b-button-toolbar>
                      </b-card-header>
                      <b-card-body class="rounded border p-2" :body-border-variant="fileItem.Id == selectedInquiryFile?.Id ? 'primary': 'white'">
                        <b-container fluid>
                          <b-row>
                            <b-col class="pt-1" md="10">
                              <b-link title="View/Download File" :href="`/api/inquiry/document/${fileItem.Id}/${fileItem.Name}?h=${fileItem.Hash}`" target="_blank">
                                <b-icon icon="file-earmark-arrow-down" /> view/download
                              </b-link>
                              ({{ fileSize(fileItem.Size) }})
                            </b-col>
                          </b-row>
                        </b-container>
                      </b-card-body>
                    </b-card>
                  </b-form-radio>
                </div>
              </b-form-radio-group>
            </b-card-body>
          </template>
        </b-card>
      </div>
    </div>

    <b-tooltip target="shipping-notes-help" placement="top">
      <ul style="text-align: left;">
        <li>Provide all the shipping requirements (Shipping Instructions, Special Instructions, Tagging Information, Additional Instructions), that is necessary for this order.</li>

        <li v-if="false">Shipping Method line is a static line that will be uploaded to all orders.</li>

        <li>To remove a line, click the trash can at the end of each line.</li>

        <li>A blank line will be visible in all sections.</li>

        <li>Once a line has any value, a new line will appear.</li>

        <li>Only line with information will be uploaded to SAP.</li>
      </ul>
    </b-tooltip>

    <b-tooltip target="purchase-order-documentation-help" placement="top">
      Drag the customer’s Purchase Order Document for this order to “Choose a file or drop it here” box. This will attach the document to the order
    </b-tooltip>

    <b-modal v-model="confirmDeleteComment" size="md" @ok="deleteComment" @hide="confirmDeleteComment = false" dialog-class="float-md-center" ok-title="Yes" cancel-title="No">
      <template #modal-header>
        Delete comment
      </template>
      <span>Please confirm you want to delete this comment</span>
    </b-modal>

  </div>
</template>

<script lang="ts">
import { IOrderComment, IOrderDocument } from '@/store/orders/types'
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import MxSite from '@/mixins/site'
import FileUpload from '@/components/utility/file-upload.vue'
import { IInquiryContact } from '@/store/inquiry/types'
import { v4 as uuidv4 } from 'uuid'

@Component({
  components: {
    'file-upload': FileUpload,
  },
})
export default class OrderComments extends Mixins(MxSite) {
  private tryClearInquiryRadios = false

  @Prop({ type: Array, default: () => [] })
  public orderItemNotes?: string[]

  @Prop({ default: () => '' })
  public incoTerms?: string

  public files: File[] = []

  public shippingMethods = ['Best Way', 'UPS', 'FedEx', 'Will Call']
  public shippingMethod: string = 'Best Way'
  public shippingNotes: string[] = ['']

  public uploadingDocument = false
  public inquiryFiles: IOrderDocument[] = []
  public commenttest: string = ''
  public confirmDeleteComment = false
  public shippingInstructions: IOrderComment[] = [{ key: uuidv4(), value: '' }]
  public commentToBeDeletedIndex!: number
  public commentsListToDeleteItem!: IOrderComment[]
  public selectedInquiryFile: IOrderDocument | null = null
  public poDocumentSelected = false
  public poDocumentNotSelectedMessage = ''

  public onInquiryFilesClick(file : IOrderDocument) {
    if (file.Id === this.selectedInquiryFile?.Id) {
      this.selectedInquiryFile = null
      this.tryClearInquiryRadios = true
    }
  }

  public onInquiryFilesChange(file: IOrderDocument) {
    if (this.tryClearInquiryRadios && file.Id === this.selectedInquiryFile?.Id) {
      this.selectedInquiryFile = null
      this.tryClearInquiryRadios = false
    }
  }

  public specialInstructions: IOrderComment[] = [
    { key: uuidv4(), value: '' },
  ]

  public taggingInformation: IOrderComment[] = [
    { key: uuidv4(), value: '' },
  ]

  public additionalInstructionsFromInquiry: IOrderComment[] = []

  public additionalInstructions: IOrderComment[] = [
    { key: uuidv4(), value: '' },
  ]

  public filesSelected(files) {
    this.files = files
    this.uploadingDocument = false
  }

  public populateFiles(files: IOrderDocument[]) {
    if (files && files.length) {
      this.inquiryFiles = files
    }
  }

  get shippingNotesText() {
    return [...this.shippingNotes, ...(this.orderItemNotes ?? [])].join('\r\n')
  }

  get comments(): IOrderComment[] {
    return [
      ...this.shippingNotes.filter(c => c.trim() !== '').map(c => ({ key: uuidv4(), value: c })),
      ...(this.orderItemNotes ?? []).filter(c => c.trim() !== '').map(c => ({ key: uuidv4(), value: c })),
      ...this.shippingInstructions.filter(c => c.value.trim() !== ''),
      ...this.specialInstructions.filter(c => c.value.trim() !== ''),
      ...this.taggingInformation.filter(c => c.value.trim() !== ''),
      ...this.additionalInstructionsFromInquiry.filter(c => c.value.trim() !== ''),
      ...this.additionalInstructions.filter(c => c.value.trim() !== ''),
    ]
  }

  @Watch('shippingMethod')
  public onUpdateShippingMethod(shippingMethod: string) {
    Vue.set(this.shippingNotes, 0, 'Shipping Method: ' + shippingMethod)
  }

  @Watch('incoTerms')
  public onUpdateIncoTerms(incoTerms: string) {
    if (incoTerms) {
      Vue.set(this.shippingNotes, 0, 'Shipping Method: ' + incoTerms)
    } else {
      Vue.set(this.shippingNotes, 0, '')
    }
  }

  @Watch('comments')
  public onUpdateComments(comments) {
    this.$emit('onCommentsChange', comments.map(c => c.value))
  }

  @Watch('inquiryFiles')
  @Watch('selectedInquiryFile')
  public onPODocumentSelected() {
    this.poDocumentSelected = this.files.length > 0 || (this.inquiryFiles.length > 0 && this.selectedInquiryFile !== null)
  }

  @Watch('files')
  public onFileSelected() {
    this.poDocumentSelected = this.files.length > 0
  }

  public populateComments(comments: string[], contact: IInquiryContact, jobName: string) {
    for (let i = 0; i < comments.length; i++) {
      this.additionalInstructionsFromInquiry[i] = { key: uuidv4(), value: comments[i] }
    }
    if (jobName) {
      this.additionalInstructionsFromInquiry.push({ key: uuidv4(), value: 'Inquiry job name: ' + jobName })
    }
    if (contact) {
      const contactDetails: any = [...Object.values(contact).filter(s => s)]
      this.additionalInstructionsFromInquiry.push({ key: uuidv4(), value: 'Inquiry Contact: ' + contactDetails.join(', ') })
    }
  }

  public fileSize(size: number): string {
    if (!+size) return '0 bytes'
    const decimals = 2
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['bytes', 'kb', 'mb']
    const i = Math.floor(Math.log(size) / Math.log(k))

    return `${parseFloat((size / Math.pow(k, i)).toFixed(dm))}${sizes[i]}`
  }

  public removeFileAt(index: number) {
    if (this.inquiryFiles[index].Id === this.selectedInquiryFile?.Id) {
      if (index === this.inquiryFiles.length - 1) {
        this.selectedInquiryFile = null
      }
    }

    this.inquiryFiles = this.inquiryFiles.filter((s, i) => i !== index)
  }

  public validate() {
    return {
      'comments': this.comments,
      'files': this.files,
      'inquiryFiles': this.inquiryFiles,
    }
  }

  public verifyPODocumentSelected() {
    this.poDocumentNotSelectedMessage = ''

    if (!this.poDocumentSelected) {
      this.poDocumentNotSelectedMessage = 'Upload the PO document or select one from inquiry files'
      return false
    }
    return true
  }

  public onShippingInstructionsChange(comment: IOrderComment) {
    this.onCommentsChange(comment, this.shippingInstructions)
  }

  public onShippingInstructionsDelete(comment: IOrderComment) {
    this.onCommentDelete(comment, this.shippingInstructions)
  }

  public onSpecialInstructionsChange(comment: IOrderComment) {
    this.onCommentsChange(comment, this.specialInstructions)
  }

  public onSpecialInstructionsDelete(comment: IOrderComment) {
    this.onCommentDelete(comment, this.specialInstructions)
  }

  public onTaggingfInformationChange(comment: IOrderComment) {
    this.onCommentsChange(comment, this.taggingInformation)
  }

  public onTaggingfInformationDelete(comment: IOrderComment) {
    this.onCommentDelete(comment, this.taggingInformation)
  }

  public onAdditionalInstructionsChange(comment: IOrderComment) {
    this.onCommentsChange(comment, this.additionalInstructions)
  }

  public onAdditionalInstructionsDelete(comment: IOrderComment) {
    this.onCommentDelete(comment, this.additionalInstructions)
  }

  public onCommentsChange(comment: IOrderComment, commentsList: IOrderComment[]) {
    const index = commentsList.indexOf(comment)
    if (index === commentsList.length - 1) {
      commentsList.push({ key: uuidv4(), value: '' })
    }
  }

  public onCommentDelete(comment: IOrderComment, commentsList: IOrderComment[]) {
    const index = commentsList.indexOf(comment)
    if (index < commentsList.length - 1) {
      this.confirmDeleteComment = true
      this.commentToBeDeletedIndex = index
      this.commentsListToDeleteItem = commentsList
    }
  }

  public deleteComment() {
    this.commentsListToDeleteItem.splice(this.commentToBeDeletedIndex, 1)
  }
}
</script>

<style scoped></style>
